// Manual optimizer stack bounds: min/max % of lineups per stack type.
export const STACK_TYPES = [
  { key: "none", label: "Naked QB", sub: "no stack rule", tid: "none" },
  { key: "qb_wr", label: "QB + 1", sub: "≥1 own WR/TE", tid: "qb_wr" },
  { key: "qb_wr_wr", label: "QB + 2", sub: "≥2 own WR/TE", tid: "qb_wr_wr" },
];

const b = (none, qb1, qb2) => ({ none, qb_wr: qb1, qb_wr_wr: qb2 });
const full = { min: 100, max: 100 };
const zero = { min: 0, max: 0 };

export const STACK_PRESETS = {
  none: { stack_mode: "none", stack_bounds: b(full, zero, zero) },
  qb1: { stack_mode: "qb_wr", stack_bounds: b(zero, full, zero) },
  qb2: { stack_mode: "qb_wr_wr", stack_bounds: b(zero, zero, full) },
  mix: { stack_mode: "qb_wr", stack_bounds: b({ min: 0, max: 20 }, { min: 30, max: 70 }, { min: 30, max: 70 }) },
};

export const DEFAULT_STACK_BOUNDS = STACK_PRESETS.none.stack_bounds;

export const normalizeBounds = (raw) => {
  const out = {};
  for (const t of STACK_TYPES) {
    const v = (raw || {})[t.key] || {};
    const min = Math.max(0, Math.min(100, Number(v.min ?? 0) || 0));
    const max = Math.max(0, Math.min(100, v.max === "" || v.max == null ? 100 : Number(v.max)));
    out[t.key] = { min, max };
  }
  return out;
};

const isFull = (v) => v.min === 100 && v.max === 100;
const isZero = (v) => v.max === 0;

export const stackPresetOf = (cfg) => {
  const bb = normalizeBounds(cfg?.stack_bounds);
  if (isFull(bb.none) && isZero(bb.qb_wr) && isZero(bb.qb_wr_wr)) return "none";
  if (isZero(bb.none) && isFull(bb.qb_wr) && isZero(bb.qb_wr_wr)) return "qb1";
  if (isZero(bb.none) && isZero(bb.qb_wr) && isFull(bb.qb_wr_wr)) return "qb2";
  return "mix";
};

export const stackBoundsIssue = (bounds) => {
  const bb = normalizeBounds(bounds);
  for (const t of STACK_TYPES) if (bb[t.key].min > bb[t.key].max) return `${t.label}: min is above max`;
  const sumMin = STACK_TYPES.reduce((s, t) => s + bb[t.key].min, 0);
  const sumMax = STACK_TYPES.reduce((s, t) => s + bb[t.key].max, 0);
  if (sumMin > 100) return `Minimums add up to ${sumMin}% — must be ≤ 100%`;
  if (sumMax < 100) return `Maximums add up to ${sumMax}% — must be ≥ 100% so every lineup has a shape`;
  return null;
};

// Any stacked shape allowed → counts as a build touch and enables bring-back.
export const stacksEnabled = (bounds) => {
  const bb = normalizeBounds(bounds);
  return bb.qb_wr.max > 0 || bb.qb_wr_wr.max > 0;
};
